import React, { useEffect, useRef, useState } from 'react'
import PagesTitle from '../../../widgets/pages_title/pages_title';
import './solution_imp.css';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { getProblemImages } from '../../../functions/get_problem';
import Slider from 'react-slick';
import { domainType, formatProblemDisplay } from '../../../global/http_enum';
import InputInfo from '../../../widgets/input_info/input_info';
import { getSolutionFromProblem } from '../../../functions/solution';
import { getCorrectionForComunicationDomain, getSolutionFromProblemMappedTo, getSolutionMappedTo } from '../../../functions/get_solution_to';
import CheckIcon from '@mui/icons-material/Check';

// Helper function to find the correct problem for an event
const findProblemForEvent = (project, selectedEvent) => {
    if (!project?.problem || !selectedEvent?.id) {
        return project?.problem?.find(obj => obj.domain === selectedEvent?.domain) || null;
    }

    // Try to get problem ID from localStorage
    try {
        const getStorageKey = () => `eventProblems_${project?.id || 'default'}`;
        const stored = localStorage.getItem(getStorageKey());
        if (stored) {
            const eventProblemMap = new Map(JSON.parse(stored));
            const problemId = eventProblemMap.get(selectedEvent.id);

            // If we have a problem ID, find by ID first
            if (problemId) {
                const problemById = project.problem.find(obj => obj.id === problemId);
                if (problemById) {
                    return problemById;
                }
            }
        }
    } catch (error) {
        console.error('Failed to load event problem map:', error);
    }

    // Fallback to domain matching
    return project.problem.find(obj => obj.domain === selectedEvent.domain) || null;
};

export default function SolutionImp({ project, selectedEvent, SetSolutionImplimantation }) {
    const [solutiionMappedTo, SetSolutionMappedTo] = useState([]);
    const theoryObject = useRef(findProblemForEvent(project, selectedEvent));
    useEffect(() => {
        theoryObject.current = findProblemForEvent(project, selectedEvent);
        if (theoryObject.current?.problem_mapped_to) {
            SetSolutionMappedTo(getSolutionMappedTo(theoryObject.current.problem_mapped_to, selectedEvent.domain))
        }
    }, [project, selectedEvent])
    const problemMappedToSliderRef = useRef();
    const solutionMappedToSliderRef = useRef();
    const correctionForCommunicationDomainSliderRef = useRef();
    const solutionHowToSliderRef = useRef();

    // Function to reset all sliders to the first slide
    const syncSliders = (index) => {
        if (document.getElementById('syncToggle').checked) {
            problemMappedToSliderRef.current.slickGoTo(index);
            solutionMappedToSliderRef.current.slickGoTo(index);
            if (selectedEvent.domain === domainType.communication) {
                correctionForCommunicationDomainSliderRef.current.slickGoTo(index);
            }
            solutionHowToSliderRef.current.slickGoTo(index);
        }
    };
    const settingsSlick = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: function (currentSlide, nextSlide) {
            syncSliders(nextSlide);
        },
    };

    return (
        <>
            <div className="title-holder">
                <PagesTitle title={'Solution Implementation'} />
                <div onClick={() => SetSolutionImplimantation(false)} className="button-with-title">
                    <ArrowBackIosNewIcon className='button-icon' />
                    <h1 className='button-text'>Back</h1>
                </div>
            </div>
            <div onClick={() => SetSolutionImplimantation(false)} className="backbutton">
                <ArrowBackIosNewIcon className='button-icon' />
                <h3 className='button-text'>Back</h3>
            </div>
            <div id="solution-imp">
                <div className="solution-imformation">
                    <InputInfo color={'1px solid rgba(36, 30, 102, 0.50)'} height={'50'} name={'Event name'} onClick={() => { }} readOnly={true} value={selectedEvent.name} />
                    <InputInfo color={'1px solid rgba(36, 30, 102, 0.50)'} height={'50'} name={'Negative Function Executed'} onClick={() => { }} readOnly={true} value={selectedEvent.negative_function_exluded} />
                    <InputInfo color={'1px solid rgba(36, 30, 102, 0.50)'} height={'50'} name={'Problem Identification'} onClick={() => { }} readOnly={true} value={formatProblemDisplay(selectedEvent.problem_identifyed_from_event)} />
                    <h1 className='selected-problem-mapped-title'>Principle deficiency</h1>
                    <div className='problem-mapped-selected'>
                        {theoryObject.current.pricipal_defeciency.map((e, index) => <div key={index} className="selected">{e} <CheckIcon className='icon' /> </div>)}
                    </div>
                    <h1 className='selected-problem-mapped-title'>Problem Mapped To</h1>
                    <div className='problem-mapped-selected'>
                        {theoryObject.current.problem_mapped_to.map((e, index) => <div key={index} className="selected">{e} <CheckIcon className='icon' /> </div>)}
                    </div>
                    <h1 className='selected-problem-mapped-title'>Solution Mapped</h1>
                    <div className='problem-mapped-selected'>
                        {solutiionMappedTo.map((e, index) => <div key={index} className="selected">{e} <CheckIcon className='icon' /> </div>)}
                    </div>

                </div>
                <div className="solution-images">
                    <label style={{ marginBottom: "20px" }} class="custom-checkbox">
                        <input type="checkbox" id="syncToggle" name="syncToggle" />
                        <span className="checkmark"></span>
                        Sync Models
                    </label>
                    <div className="images">
                        <h1 className='title'>Problem Mapped To</h1>
                        <Slider ref={problemMappedToSliderRef} className='carasoul-box'  {...settingsSlick}>
                            {getProblemImages(theoryObject.current.problem_mapped_to, selectedEvent.domain).map((e, index) => <img alt=' ' src={e} key={index} ></img>)}
                        </Slider>
                    </div>
                    <div className="images">
                        <h1 className='title'>Solution Mapped To</h1>
                        <Slider ref={solutionMappedToSliderRef} className='carasoul-box' {...settingsSlick}>
                            {getSolutionFromProblem(theoryObject.current.problem_mapped_to, selectedEvent.domain).map((e, index) => <img alt=' ' src={e} key={index} ></img>)}
                        </Slider>
                    </div>
                    {selectedEvent.domain === domainType.communication ?
                        <div className="images">
                            <h1 className='title'>Correction</h1>
                            <Slider ref={correctionForCommunicationDomainSliderRef} className='carasoul-box'  {...settingsSlick}>
                                {getCorrectionForComunicationDomain(theoryObject.current.problem_mapped_to,).map((e, index) => <img alt=' ' src={e} key={index} ></img>)}
                            </Slider>
                        </div>
                        : <></>}

                    <div className="images">
                        <h1 className='title'>Solution How To</h1>
                        <Slider ref={solutionHowToSliderRef} className='carasoul-box'  {...settingsSlick}>
                            {getSolutionFromProblemMappedTo(theoryObject.current.problem_mapped_to, selectedEvent.domain).map((e, index) => <img alt=' ' src={e} key={index} ></img>)}
                        </Slider>
                    </div>

                </div>
            </div>
        </>
    )
}
